import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box, Button, Dialog, Typography } from "@mui/material";
import { formatTimeInTimezone } from "@notemeal/utils-date-time";

interface OrderConfirmationScreenProps {
  open: boolean;
  orderCode: string;
  pickupTime: string;
  mealMenuTimezone: string;
  smsPhoneLast4?: string | null;
  onBackToMenu: () => void;
}

export const OrderConfirmationScreen = ({
  open,
  orderCode,
  pickupTime,
  mealMenuTimezone,
  smsPhoneLast4,
  onBackToMenu,
}: OrderConfirmationScreenProps) => (
  <Dialog open={open} fullScreen PaperProps={{ sx: { bgcolor: "common.white" } }}>
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", gap: 5, p: 4 }}>
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 3, maxWidth: 547, width: "100%" }}>
        <CheckCircleIcon sx={{ fontSize: 40, color: "success.main" }} />
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1, textAlign: "center" }}>
          <Typography variant="h1" sx={{ fontSize: 24, fontWeight: 600 }}>
            You&apos;re all set!
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Your order has been placed.
            {smsPhoneLast4 && ` We will text ...${smsPhoneLast4} when your order is ready for pickup.`}
          </Typography>
        </Box>
        <Box sx={{ border: 1, borderColor: "grey.300", borderRadius: 1.5, p: 2, width: "100%", display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Typography variant="body2" color="textSecondary" sx={{ width: 100 }}>
              Order Number
            </Typography>
            <Typography variant="body1Semibold">#{orderCode}</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Typography variant="body2" color="textSecondary" sx={{ width: 100 }}>
              Pickup Time
            </Typography>
            <Typography variant="body1Semibold">
              {formatTimeInTimezone(pickupTime, mealMenuTimezone, { alwaysShowMinutes: true })}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Button
        variant="contained"
        size="large"
        onClick={onBackToMenu}
        sx={{
          maxWidth: 547,
          width: "100%",
          bgcolor: "common.black",
          color: "common.white",
          "&:hover": { bgcolor: "common.black" },
        }}
      >
        Back to Menu
      </Button>
    </Box>
  </Dialog>
);
